module.exports = __webpack_public_path__ + "img/shield-check.faa9d85b.svg";